<template>
  <v-container v-if="$store.getters.user" class="test_red">
    <v-row justify="center" no-gutters class="test_blue">
      <v-col cols="12" md="10" lg="8" class="test_yellow">
        <div class="content">
          <div style="margin-top: 30px">
            <h1 style="margin-left: 10px">
              {{ $t("customerProfile.creditComp.title") }}
            </h1>
          </div>
          <p class="subtitle" style="margin-bottom: 30px">
            {{ $t("customerProfile.creditComp.description") }}
          </p>
          <div class="box" style="margin-bottom: 20px">
            <div>
              <h2>App Credits</h2>
              <p style="font-size: 1.1rem">DKK {{ user.credits }}</p>
            </div>
            <v-icon large style="padding-right: 10px">
              mdi-chevron-right
            </v-icon>
          </div>
          <div class="box">
            <div style="width: 75%">
              <v-text-field
                v-model="credits"
                class="text-input"
                :placeholder="$t('customerProfile.creditComp.inputText')"
              ></v-text-field>
            </div>
            <v-btn
              class="share-button"
              style="font-size: 1rem; padding: 25px"
              @click="checkCode()"
            >
              {{ $t("customerProfile.creditComp.buttonText") }}
            </v-btn>
          </div>
          <v-row
            v-if="error"
            style="margin-top: 20px; width: 100%; margin-left: 5px"
          >
            <v-banner
              icon="$warning"
              color="error"
              class="my-2"
              width="100%"
              style="color: white"
              icon-color="white"
            >
              <v-banner-text> {{ error }}</v-banner-text>
            </v-banner>
          </v-row>
          <v-row
            v-if="offer"
            style="margin-top: 20px; width: 100%; margin-left: 5px"
          >
            <v-banner
              icon="$success"
              color="success"
              class="my-2"
              width="100%"
              style="color: white"
              icon-color="white"
            >
              <v-banner-text>
                {{
                  $t("customerProfile.creditComp.success", {
                    amount: offer.value,
                  })
                }}</v-banner-text
              >
            </v-banner>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CreditComponent",
  data: () => ({
    credits: null,
    error: null,
    offer: null,
  }),
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    checkCode: async function () {
      const form = new Form({
        code: this.credits,
      });
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await form.post("/app/v2/features/promo/validate");

      switch (true) {
        case data.status === "False":
          if (data.message === "NOT_VALID") {
            this.error = self.$t("offers.NOT_VALID");
          } else if (data.message === "ALREADY_USED_CODE") {
            this.error = self.$t("offers.ALREADY_USED_CODE");
          }
          this.offer = undefined;
          break;
        case data.status === "Success":
          if (!data.data.is_credit) {
            this.offer = undefined;
            this.error = self.$t("offers.NOT_VALID");
          } else {
            this.error = undefined;
            this.offer = data.data;
            await this.$store.dispatch("auth/fetchUser");
            setTimeout(() => {
              this.offer = undefined;
            }, 6000);
          }
          break;
        default:
          this.error = undefined;
          this.offer = null;
          break;
      }
      self.$store.dispatch("loading/done");
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.circle-number {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 50%;
  background-color: #eaf5fc;
  width: 30px;
  height: 30px;
  color: var(--v-primary-base) !important;
}
.title {
  flex: 1;
}
.title2 {
  flex: 1;
  font-size: 1rem;
}
.text-input {
  margin-left: 10px;
  width: 100%; /* Adjust the width as per your requirement */
}
.share-button {
  margin-left: 10px;
  color: white;
  background-color: var(--v-primary-base) !important;
}
.subtitle {
  //color: var(--v-primary-base) !important;
  font-size: 16px;
  text-align: center;
}
.wrap-text {
  white-space: normal;
}
.box {
  background-color: rgb(245, 245, 245);
  display: flex;
  border-radius: 5px;
  border-width: 2px !important;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 20px;
  margin-left: 10px;
}
.divider-text {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  color: #999;
}
</style>
